module.exports = __webpack_public_path__ + "static/media/godt.2cd91b44.mp3";